export enum DNVReportType {
    OVDLA = 0,
    OVDBR = 1,
    OVDBRBdnBased = 2,
    OVDBRDebunkering = 3,
}
